import { LegacyFilter } from "@budibase/types"

export type UILegacyFilter = LegacyFilter & {
  id: string
}
